import moment from 'moment';
import Vue from '../vue';
import router from '../router';

export const setStorePrototypes = store => {
  Vue.prototype.windowSize = store.getters.windowSize;
  Vue.prototype.$store = store;
  Vue.prototype.console = console;
  Vue.prototype.$confirm = function (title, message, options = {}) {
    store.state.modalConfirm = {
      show: true,
      title: title,
      message: message,
      okText: 'Ok',
      okTitle: '',
      cancelText: 'Cancel',
      cancelTitle: '',
      ...options,
    };

    return new Promise((resolve, reject) => {
      store.state.modalConfirm.resolve = () => {
        store.state.modalConfirm.show = false;
        resolve(store.state.modalConfirm.option);
      };
      store.state.modalConfirm.reject = () => {
        store.state.modalConfirm.show = false;
        reject(false); // eslint-disable-line
      };
    });
  };
  Vue.prototype.$alert = function (title, message) {
    var args = arguments;
    store.state.modalAlert.show = true;
    store.state.modalAlert.title = title;
    store.state.modalAlert.message = message;
    return new Promise(resolve => {
      store.state.modalAlert.resolve = () => {
        store.state.modalAlert.show = false;
        resolve(args[2]);
      };
    });
  };


  Vue.prototype.browserDateTime = (date, format) => {
    if (!date) return date;
    return moment.utc(date).local().format(format || "MM/DD/YYYY hh:mm A");
  };
  Vue.prototype.browserTime = (date, format) => Vue.prototype.browserDateTime(date, format || "hh:mm:ss A");
  Vue.prototype.browserDate = (date, format) => Vue.prototype.browserDateTime(date, format || "MM/DD/YYYY");

  //Date format is used to represent dates. It does not convert date to local.
  Vue.prototype.dateFormat = (date) => {
    if (!date) return date;
    return moment(date).format("MM/DD/YYYY");
  };

  Vue.prototype.goTo = function (url) {
    var routerLink = (router.match(url).matched || [])[0];
    if (routerLink) {
      var currentRoute = router.currentRoute;
      if (currentRoute.name !== routerLink.name || router.currentRoute.fullPath !== routerLink.path) {
        router.push(url);
      }
    } else {
      store.state.isAppLoading = true;
      window.location = url;
    }
  }

  Vue.prototype.getFlag = flag => (store.state.flags || {})[flag];

  window.addEventListener('resize', () => {
    store.state.windowHeight = window.innerHeight;
    store.state.windowWidth = window.innerWidth;
  });
};